document.querySelector('[data-cookie-policy]').addEventListener("click", event => {
    document.querySelector('.cc-revoke').click();
});